// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { goBack } from 'react-router-redux'
import { initialize } from 'redux-form'
import { loadingToggler } from 'redux/modules/loading'
import { success } from 'react-notification-system-redux'
import { throwSubmissionError } from 'helpers/reduxFormFunctions'
import { putAFSFilterUpdate } from 'helpers/api'
import formatFilterForAPI from './formatFilterForAPI'
import { AFS_RESULTS_FILTER } from 'redux/modules/interferenceAnalysis/constants'

const handleFilterSubmit = formValues => dispatch => (
  dispatch(loadingToggler(
    async () => {
      // grab the AFS filter id from the form. This value does not have a corresponding input field.
      const { afsFilterId } = formValues

      const updatedFilter = formatFilterForAPI(formValues)

      try {
        await putAFSFilterUpdate(afsFilterId, updatedFilter)

        // reinitialize this form so that it is no longer dirty.
        // this allows us to avoid the discard prompt when goBack is called a few lines below.
        await dispatch(initialize(AFS_RESULTS_FILTER, formValues))

        // let them know it was a success
        await dispatch(success({
          autoDismiss: 3,
          title: 'Successfully updated the AFS Filter.',
        }))

        // send the user back to wherever they came from. This way we don't need
        // to know if we should go back to the AFS Grid or to a Case Details.
        return dispatch(goBack())
      } catch (err) {
        console.warn(err)
        throwSubmissionError(err)
      }
    })
  )
)

export default handleFilterSubmit
